import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './home.css'
import img from '../../assets/me.JPG'

export default class extends Component {
  boxWidth = React.createRef()
  state = {
    width: 0
  }

  componentDidMount() {
    this.setState({ width: this.boxWidth.current.clientWidth + 'px' })
  }
  render() {
    return (
      <div className="home">
        <div className="container">
          <div className="row py-3" style={{ alignItems: 'center' }}>
            <div className="col-md-5 col-xs-12 col-sm-12">
              <img
                src={img}
                alt="me, alif irfan anshory"
                className="img-profile"
              />
              <h1 className="title">
                Alif Irfan <br /> Anshory
              </h1>
              <hr className="my-4" />
              <div className="desc">
                Hi there! I'm a javascript enthusiast! I've been strugling with
                JS since 2016. Interested to collaborate? Just{' '}
                <a href="mailto:alif.anshory16@gmail.com">contact me</a> or
                click button below ASAP. ;)
                <div className="flex-wrap mt-3 mail-container">
                  <a
                    href="mailto:alif.anshory16@gmail.com"
                    className="btn btn-primary"
                    style={{ color: 'white' }}
                  >
                    <i className="fa fa-envelope" />
                  </a>
                  <a
                    style={{ color: 'white' }}
                    href="mailto:alif.anshory16@gmail.com"
                    className="btn btn-primary"
                  >
                    HIRE ME!
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-1 hidden-xs" />
            <div className="col-md-6 col-xs-12 col-sm-12 pics">
              <div className="row">
                <div className="col-3">
                  <div className="row box-container">
                    <div
                      className="col-md-12 col-xs-6 box"
                      style={{ height: this.state.width }}
                      ref={this.boxWidth}
                    >
                      <Link to="/skills">
                        <i className="fa fa-bolt" />
                        <p>Skills</p>
                      </Link>
                    </div>
                    <div
                      className="col-md-12 col-xs-6 box"
                      style={{ height: this.state.width }}
                    >
                      <Link to="/works">
                        <i className="fa fa-briefcase" />
                        <p>Work Exp</p>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-6 project box">
                  <Link to="/projects">
                    <i className="fa fa-pencil" />
                    <p>Projects</p>
                  </Link>
                </div>
                <div className="col-3">
                  <div className="row box-container">
                    <div
                      className="col-md-12 col-xs-6 box"
                      style={{ height: this.state.width }}
                    >
                      <Link to="/medium">
                        <i className="fa fa-medium" />
                        <p>Medium Articles</p>
                      </Link>
                    </div>
                    <div
                      className="col-md-12 col-xs-6 box"
                      style={{ height: this.state.width }}
                    >
                      <a href="https://github.com/alfari16" target="_blank">
                        <i className="fa fa-github" />
                        <p>Github</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/home.js